import React from 'react';
import PropTypes from 'prop-types';
import {
  SuffixIcon,
  PrefixIcon,
  InputWrapper,
  Error,
  StyledInput
} from './elements';
import { getIcon } from 'assets/icons';

export function Input(props) {
  const { id, autocomplete, Icon, ...args } = props;
  let prefix = null;
  let suffix = null;
  if (typeof props.prefixIcon === 'string') {
    const Icon = getIcon(props.prefixIcon);
    prefix = (
      <PrefixIcon>
        <Icon />
      </PrefixIcon>
    );
  }

  if (typeof props.suffixIcon === 'string') {
    const Icon = getIcon(props.suffixIcon);
    suffix = (
      <SuffixIcon onClick={props.onSubmit}>
        <Icon />
      </SuffixIcon>
    );
  }
  return (
    <InputWrapper>
      {prefix}
      <StyledInput
        {...args}
        id={id}
        autocomplete={autocomplete ? autocomplete : id}
      />
      {suffix}
      {props.error ? <Error>{props.error}</Error> : null}
    </InputWrapper>
  );
}

Input.defaultProps = {
  prefixIcon: null,
  suffixIcon: null,
  placeholder: '',
  defaultValue: undefined,
  disabled: false,
  error: '',
  variant: 'default',
  type: 'text'
};

Input.propTypes = {
  prefixIcon: PropTypes.string,
  // suffixIcon: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string,
  variant: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string.isRequired
};

export default Input;
